import type {
  EnhancedConfigTypeId,
  EnhancedLanguageId,
  EnhancedManCodeId,
  EnhancedMarketId,
  EnhancedVehicleTypeId,
  EnhancedViewId,
} from '#api/enhancements/enhancedTmsApiTypes.ts'
import type { ConfigurationStep } from '#features/Configuration/ConfigurationStep'
import type { DateString } from '#utils/DateString'

export type ConfigurationMode = 'writable' | 'read-only' | 'stashed' | 'cloned'

export interface FullApiConfiguration {
  step?: ConfigurationStep
  backUrl?: string

  // YYYY-MM-DD
  partPeriod?: DateString
  // YYYY-MM-DD
  desiredDealerDate?: DateString
  desiredDealerDateIsEstimate?: boolean
  // YYYY-MM-DD
  pricingDate?: DateString

  market: EnhancedMarketId
  vehicleType: EnhancedVehicleTypeId
  configurationType?: EnhancedConfigTypeId
  view: EnhancedViewId
  language?: EnhancedLanguageId

  callingSystem?: string

  manCode?: EnhancedManCodeId
  mode?: ConfigurationMode

  orderCountry?: string
  orderLanguage?: string

  // allows to override the marketId in the market API call that loads the national codes
  nationalCodeMarketIdOverride?: EnhancedMarketId
}

export type ManCodeApiConfiguration = Partial<FullApiConfiguration> & {
  manCode: EnhancedManCodeId
  mode: ConfigurationMode
}

export type Tg3ApiConfiguration = {
  tg3Code: string
  orderLanguage?: string
  orderCountry?: string
}

export type OverrideableApiConfiguration = FullApiConfiguration | ManCodeApiConfiguration

export type ApiConfiguration = ManCodeApiConfiguration | FullApiConfiguration | Tg3ApiConfiguration

export function isManCodeApiConfiguration(config: ApiConfiguration | undefined): config is ManCodeApiConfiguration {
  return !!config && 'manCode' in config && config.manCode !== undefined
}

export function isFullApiConfiguration(config: ApiConfiguration | undefined): config is FullApiConfiguration {
  return !!config && 'market' in config && 'vehicleType' in config && 'view' in config && config.manCode === undefined
}

export function isTg3ApiConfiguration(config: ApiConfiguration | undefined): config is Tg3ApiConfiguration {
  return !!config && 'tg3Code' in config && config.tg3Code !== undefined
}
